import { Slider } from "./ui/slider";

export interface OpacitySliderProps {
  value: number; // 0..100
  onChange: (value: number) => void;
}

/**
 * The slider value (0–100) represents the user-image opacity over the
 * standard template. 0 = pure template, 100 = pure user.
 */
export function OpacitySlider({ value, onChange }: OpacitySliderProps) {
  return (
    <div className="flex w-full items-center gap-3">
      <span className="w-12 shrink-0 text-xs text-[color:var(--text-muted)]">模板</span>
      <Slider value={value} min={0} max={100} step={1} onValueChange={onChange} />
      <span className="w-12 shrink-0 text-right text-xs text-[color:var(--text-muted)]">用户</span>
      <span className="w-10 shrink-0 text-right text-sm tabular-nums text-[color:var(--text)]">
        {value}%
      </span>
    </div>
  );
}
